export default __webpack_public_path__ + "static/media/partner_logo_vipps.deb4aa9b.svg";